import { render, staticRenderFns } from "./AscSectionHeader.vue?vue&type=template&id=8d05592c&"
import script from "./AscSectionHeader.vue?vue&type=script&lang=js&"
export * from "./AscSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./AscSectionHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports